export default __webpack_public_path__ + "static/media/Soudeur.da25a457.webp";